import React from 'react';
import { Text, Group, Link } from '@landr/maestro';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import { TrendingLink } from '../type';

export const TrendingLinks = ({
    trendings,
    onClick,
}: {
    trendings: TrendingLink[];
    onClick: (event: React.MouseEvent) => void;
}) => {
    const toLocalizedPath = useToLocalizedPath();

    return (
        <Text contrast="low">
            <Group gutter="xs" flexWrap="wrap">
                {trendings.map(({ to, label }, index) => (
                    <Group.Item>
                        <Group gutter="xs">
                            <Group.Item>
                                <Link
                                    href={toLocalizedPath(`/${to}`)}
                                    onClick={onClick}
                                    hasUnderline="hover"
                                >
                                    {label}
                                </Link>
                            </Group.Item>
                            {index + 1 !== trendings.length && (
                                <Group.Item>•</Group.Item>
                            )}
                        </Group>
                    </Group.Item>
                ))}
            </Group>
        </Text>
    );
};
